import { useEffect, useState } from 'react'
import { OtherAvailabilitySection, useOtherAvailabilitySectionBaseSpacing } from '@/Reservations/Search/OtherAvailability'
import { reservationWidgetMessages } from '@/reservationWidgetMessages'
import { useLocales } from '@sevenrooms/locales'
import {
  PrivateEventsOtherVenuesAvailability,
  type PrivateEventsOtherVenuesAvailabilityProps,
} from '../PrivateEventsOtherVenuesAvailability'

export interface PrivateEventsCrossSellProps extends PrivateEventsOtherVenuesAvailabilityProps {}

export function PrivateEventsCrossSell(props: PrivateEventsCrossSellProps) {
  const { formatMessage } = useLocales()
  const baseSpacing = useOtherAvailabilitySectionBaseSpacing()
  const { startDate, haloTimeIntervalMinutes, startTime, partySize } = props
  const [otherVenuesCollapsed, setOtherVenuesCollapsed] = useState(true)

  useEffect(() => {
    // Should collapse when the filter values changes.
    setOtherVenuesCollapsed(true)
  }, [startDate, haloTimeIntervalMinutes, startTime, partySize])

  return (
    <OtherAvailabilitySection
      collapsed={otherVenuesCollapsed}
      setCollapsed={setOtherVenuesCollapsed}
      title={formatMessage(reservationWidgetMessages.resWidgetOtherLocationsLabel)}
    >
      <PrivateEventsOtherVenuesAvailability
        {...props}
        desktopVariant="short"
        hideExperiencesWithoutAvailability
        hideRequestButton
        useHorizontalScroll
        scrollRightMargin={baseSpacing}
      />
    </OtherAvailabilitySection>
  )
}
